import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SundryChecklistBPLReport } from './Pages';

export const SundryChecklistBPLReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SundryChecklistBPLReport} />

    </Fragment>
)